import Fulllayout from "../layouts/fulllayout.js";
import PrintInvoice from "../components/MobilePrint/print-invoice";

var indexRoutes = [
  { path: "/", name: "Dashboard", component: Fulllayout },
  { path: "/print-invoice", name: "Dashboard", component: PrintInvoice },
];

export default indexRoutes;
